import { AxiosInstance } from 'axios';

export class DNSCache {
  dnsResolve: any;

  axiosMap = new Map<string, AxiosInstance>();

  isRegistered = false;

  init(isPC = false) {
    if (isPC && !this.dnsResolve) {
      this.dnsResolve = (window.parent as any).require('@wonder233/axios-cached-dns-resolve');

      this.dnsResolve.changeLogger(logger.ui);

      this.dnsResolve.config.dnsTtlMs = 60000; // 将dns缓存设置为一分钟
      const { dnsTtlMs, cacheGraceExpireMultiplier } = this.dnsResolve.config;
      this.dnsResolve.cacheConfig.ttl = dnsTtlMs * cacheGraceExpireMultiplier;
      this.dnsResolve.reset();
      this.dnsResolve.init(); // 重新初始化
    }
  }
  /**
   * @description 增加DNS缓存
   * @param {AxiosInstance} axios
   * @memberof DNSCache
   */
  registerIntercepter(axios: AxiosInstance) {
    if (this.dnsResolve) {
      this.isRegistered = true;
      this.dnsResolve.registerInterceptor(axios);
    }
  }

  logDnsCacheInfo() {
    if (this.dnsResolve) {
      const dnsEntries = this.dnsResolve.getDnsCacheEntries();
      const dnsInfo = dnsEntries?.map((item: { host: string; ips: string[] }) => ({
        host: item.host,
        ips: item.ips,
      }));
      logger.ui.error(`[SMH DNS] ${JSON.stringify(dnsInfo)}`);
    }
  }
}

const dnsCache = new DNSCache();

export default dnsCache;
